module.exports = __webpack_public_path__ + "img/img004.30e8ed4b.png";